
import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { daysOfOperation } from '../../../constants/constants';
// eslint-disable-next-line no-unused-vars
import { htmlToText } from '../../../utils/globalMethods';

const theme = createTheme({
    typography: {
      h6: {
        fontFamily: "Texta-bold",
      },
      subtitle1: {
        fontFamily: ["Texta-book", "Helvetica", "Arial", "sans-serif"].join(','),
        fontSize: 20,   
      },
    },
  });
const CancelDetails = (props) => {

    const {row,language} = props
    const filterDay = (dayValue) => {
        let tempData = daysOfOperation.filter((data) => data.weekDay === dayValue);
        
        if (tempData.length > 0) {
            return tempData[0].values;
        } else {
            return []; 
        }
    };
  return (
    <Grid container className="collapsibleTable" spacing={2}>
        <ThemeProvider theme={theme}>
            <Grid item xs={6}>
                <Typography variant="h6" gutterBottom component="div">
                    {language.description}
                </Typography>
                {/* <Typography variant="subtitle1" gutterBottom className="share-desc"> */}
                    <span className='cancel-info share-desc'>{row.dsc ? row.dsc : '-'}</span>
                    
                    {/* <span dangerouslySetInnerHTML={{ __html: htmlToText(row.dsc)}} /> */}
                {/* </Typography> */}
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                     {language.WeightAmountOfGoods}
                 </Typography> 
                 {/* <Typography variant="subtitle1" gutterBottom> */}
                    <span className='cancel-info'>{row.shareQty}</span>
                    
                {/* </Typography> */}
            </Grid>
            {/* <Grid item xs={4}>     {(row.shareQtyUnit === "qty") ? "Units" : "Pounds"}
                <Typography variant="h6" gutterBottom component="div">
                     Farm Contact Info
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                    {row.contactInfo ? row.contactInfo : '-'}
                </Typography>
            </Grid> */}
            <Grid item xs={6}>
                    <Typography variant="h6" gutterBottom component="div">
                        {language.pickupDelivery}
                        </Typography>
                    {/* <Typography variant="subtitle1" gutterBottom> */}
                        <span className='cancel-info'>

                    {
                        row.address1 || row.address2 || row.city || row.state || row.zipcode
                            ? [
                                row.address1,
                                row.address2,
                                row.city,
                                row.state,
                                row.zipcode
                            ]
                                .filter(value => value !== undefined && value !== "")
                                .join(", ")
                            : "-"
                    }
                        </span>
                    {/* </Typography> */}
            </Grid>
            {row.day && (
            <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom component="div">
                        {language.PickupDayTime}
                        </Typography>
                    {/* <Typography variant="subtitle1" gutterBottom> */}
                    <span className='cancel-info'>

                        <AccessTimeRoundedIcon fontSize="small" />{" "}
                        {[ 
                            filterDay(row?.day), 
                            row?.openTime,
                            row?.closeTime 
                            ]
                      .filter(value => value !== undefined && value !== "")
                      .join("- ") || "-"
                      }
                    </span>
                    {/* </Typography> */}
            </Grid>
            )}
        </ThemeProvider>
    </Grid>

  )
}

CancelDetails.propTypes = {
    row: PropTypes.object.isRequired,
    language: PropTypes.object,

};
export default CancelDetails